"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Th_1 = require("../Th");
var Td_1 = require("../Td");
require("./Tr.css");
var styles = require("../../Table.css");
var Tr = /** @class */ (function (_super) {
    __extends(Tr, _super);
    function Tr(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            collState: _this.props.options.collapsible,
            collapsible: _this.props.options.collapsible,
            expState: _this.props.options.expanded,
            expanded: _this.props.options.expanded,
        };
        _this.renderChildren = _this.renderChildren.bind(_this);
        _this.getStyles = _this.getStyles.bind(_this);
        return _this;
    }
    Tr.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        this.setState({
            collapsible: this.props.options.collapsible,
            expanded: this.props.options.expanded,
        });
        if (this.props.options.expanded && this.state.expState) {
            this.setState({ expState: false });
        }
        if (this.props.options.collapsible && this.state.collState) {
            this.setState({ collState: false });
        }
    };
    Tr.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (this.props.options.expanded && !this.state.expState) {
            this.setState({ expState: true });
        }
        if (this.props.options.collapsible && !this.state.collState) {
            this.setState({ collState: true });
        }
    };
    Tr.prototype.getStyles = function () {
        if (this.props.options.dataChildRow === 'childRow') {
            if (this.props.options.expanded === true) {
                return true;
            }
            else if (this.props.options.collapsible && this.state.collState) {
                return false;
            }
            else {
                return true;
            }
        }
        else if (this.props.options.dataChildRow !== 'childRow') {
            return true;
        }
    };
    Tr.prototype.render = function () {
        var classnames = [this.props.options.className];
        if (this.props.options.collapsible) {
            classnames.push(styles.collapsible);
        }
        if (this.props.options.expanded && this.state.expState) {
            classnames.push(styles.expanded);
        }
        return (React.createElement("tr", { "data-test-id": this.props.testId, className: classnames.join(' '), style: this.getStyles() ? { display: 'table-row' } : { display: 'none' }, "data-tr": this.props.options.dataChildRow }, this.renderChildren()));
    };
    Tr.prototype.renderChildren = function () {
        var _this = this;
        return React.Children.map(this.props.children, function (child, index) {
            if (child.type !== Th_1.default && child.type !== Td_1.default) {
                // tslint:disable-next-line:no-console
                console.error(child.type + " is not allowed child of Tr component");
                return null;
            }
            var childProps = {
                options: __assign(__assign({}, child.props.options), { collapsible: _this.props.options.collapsible, expanded: _this.props.options.expanded, rowspan: _this.props.options.rowCount + 1 }),
            };
            if (_this.props.events) {
                if (_this.props.events.onSort && child.type === Th_1.default) {
                    childProps.events = __assign(__assign({}, child.props.events), { onSort: _this.props.events.onSort });
                }
                else if (_this.props.options.collapsible && _this.props.events.onToggleCollapse && child.type === Td_1.default) {
                    childProps.options = __assign(__assign({}, childProps.options), { collapsible: _this.props.options.collapsible, expanded: _this.props.options.expanded, rowspan: _this.props.options.rowCount + 1 });
                    childProps.events = __assign(__assign({}, child.props.events), { onToggleCollapse: _this.props.events.onToggleCollapse });
                }
            }
            return React.cloneElement(child, childProps);
        });
    };
    Tr.defaultProps = {
        options: {
            className: '',
        },
    };
    return Tr;
}(React.Component));
exports.default = Tr;
//# sourceMappingURL=Tr.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/containers/Table/components/Tr/Tr.js
// module id = 1365
// module chunks = 8